import { Component, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TemplatesComponent } from '../../templates.component';

@Component({
    selector: 'app-delete-template',
    templateUrl: './delete-template.dialog.html',
    styleUrls: ['./delete-template.dialog.sass'],
    standalone: false
})
export class DeleteTemplateDialog {

  constructor(
    public dialogRef: MatDialogRef<TemplatesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) { }

  onCancel(): void {
    this.dialogRef.close();
  }
}
